module.exports = __webpack_public_path__ + "img/ToDustLoggaSand.44657ff3.png";